var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.7,
    height: 31.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.1L.6 16.5a1.7 1.7 0 010-2.3L14.2.5a1.7 1.7 0 012.3 0l13.7 13.7a1.7 1.7 0 010 2.3l-1.6 1.6a1.7 1.7 0 01-2.4 0l-8-8.5v20.2a1.7 1.7 0 01-1.7 1.7h-2.3a1.7 1.7 0 01-1.7-1.7V9.6l-8 8.5A1.7 1.7 0 012 18z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.514e00a6d495a9258e7a0cf55c26be5f.svg";
export { ForwardRef as ReactComponent };